module.exports = __webpack_public_path__ + "media/Seasoning.4a2f2da7.svg";